"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./IconButton.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var getSize = function getSize(size) {
  var forIcon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var baseSize;
  if (size && ['large', 'small', 'x-small'].includes(size.toString())) {
    switch (size) {
      case 'large':
        baseSize = 40;
        break;
      case 'small':
        baseSize = 32;
        break;
      case 'x-small':
        baseSize = 24;
        break;
    }
  } else if (typeof size === 'number') {
    baseSize = size;
  }
  if (forIcon && baseSize !== undefined) {
    var offset = baseSize <= 16 ? 4 : 8;
    return baseSize - offset;
  }
  return baseSize;
};
var IconButton = _ref => {
  var Icon = _ref.Icon,
    className = _ref.className,
    color = _ref.color,
    isDisabled = _ref.isDisabled,
    isFilled = _ref.isFilled,
    label = _ref.label,
    onClick = _ref.onClick,
    size = _ref.size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    variant = _ref.variant;
  var handleOnClick = event => {
    event.stopPropagation();
    onClick(event);
  };
  var buttonSize = getSize(size);
  var iconSize = getSize(size, true);
  var buttonStyle = {
    width: buttonSize ? "".concat(buttonSize, "px") : undefined,
    height: buttonSize ? "".concat(buttonSize, "px") : undefined
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)('zui-iconButton', "zui-iconButton-color-".concat(color), "zui-iconButton-variant-".concat(variant), className),
    disabled: isDisabled,
    onClick: handleOnClick,
    type: type,
    style: buttonStyle
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    label: label,
    size: iconSize,
    isFilled: isFilled
  }));
};
exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.js.map